module.exports = __webpack_public_path__ + "static/media/img-app-interview-pass@3x.313335fb.png";